import React from 'react';
import InfluencerTile from '../components/InfluencerTile';
import isEqual from 'lodash/isEqual';
import { is } from 'immutable';

const gridContainer = {
  display: 'flex',
  flexWrap: 'wrap',
};

class InfluencerTiles extends React.Component {

  shouldComponentUpdate(newProps) {
    // Opening Filter drawer was re-rendering list, so this is
    // put in place to short circuit that unless influencer data changes
    // TODO: Find out why the view is re-rendering in the first place.

    return !is(this.props.influencers, newProps.influencers);
  }

  render() {
    return (
      <div style={gridContainer}>
        {this.props.influencers.map(influencer =>
          <InfluencerTile
            key={influencer.get('id')}
            influencer={influencer.toJS()}
            openInfluencerDeleteWarning={this.props.openInfluencerDeleteWarning}
            handleEditInfluencer={this.props.handleEditInfluencer}
            handleViewInfluencerDetails={this.props.handleViewInfluencerDetails}
          />
        )}
      </div>
    );
  }
};

export default InfluencerTiles;



/** WEBPACK FOOTER **
 ** ./components/InfluencerTiles.js
 **/